import { createSelector } from 'reselect';

export const getOrderDetailsList = state => Object.values(state.orders || {}) || [];
export const getOrderNumbersList = state => Object.keys(state.orders || {}) || [];

const ordersWithJabberNode = (ordersDetails = []) => ordersDetails.filter(order => !!order.jabber_node);

export const getOrdersWithJabberNode = createSelector([getOrderDetailsList], ordersWithJabberNode);
